/**
 * Pre-compiled pt-BR messages for RichTextInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  bold: `Negrito`,
  bulletedList: `Lista com marcadores`,
  code: `Código`,
  headingFive: `Cabeçalho 5`,
  headingFour: `Cabeçalho 4`,
  headingOne: `Cabeçalho 1`,
  headingThree: `Cabeçalho 3`,
  headingTwo: `Cabeçalho 2`,
  italic: `Itálico`,
  listFormatting: `Formatação de lista`,
  moreFormattingOptions: `Mais opções de formatação`,
  moreStyles: `Mais estilos`,
  numberedList: `Lista numerada`,
  paragraph: `Parágrafo`,
  quote: `Cotação`,
  redo: `Refazer`,
  strikethrough: `Tachado`,
  subscript: `Subscrito`,
  superscript: `Sobrescrito`,
  textFormatting: `Formatação de texto`,
  textStyle: `Estilo de texto`,
  textStyleMenu: `Menu de estilo de texto`,
  underline: `Sublinhado`,
  undo: `Desfazer`,
};
